export const simpleTypeCheck = (value) => value === null || (typeof value !== "object" && typeof value !== "function");
//# sourceMappingURL=simpleTypeCheck.js.map